import { createReducer } from '../helpers';
import { checkout } from '../actions';
import { CHECKOUT_STATUSES } from '../constants';

const initialState = {
    price: null,
    status: CHECKOUT_STATUSES.initial,
};

function changePrice(state, action) {
    state.price = action.payload.price;
}

function reset(state) {
    state.price = initialState.price;
    state.status = initialState.status;
}

export default createReducer(initialState, {
    [checkout.load]: (state, action) => {
        state.status = CHECKOUT_STATUSES.loaded;
        state.price = action.payload.price;
    },
    [checkout.changeCountry]: changePrice,
    [checkout.applyCoupon]: changePrice,
    [checkout.removeCoupon]: changePrice,
    [checkout.completePayment]: (state, action) => {
        state.status = action.payload?.isPendingReview
            ? CHECKOUT_STATUSES.pending_review
            : CHECKOUT_STATUSES.complete_payment_successfully;
    },
    [checkout.reset]: reset,
    [checkout.close]: reset,
    [checkout.applyPlan]: (state) => {
        state.status = CHECKOUT_STATUSES.applied_plan;
    },
});
